import { Route, Routes, useLocation } from 'react-router-dom';
import Home from './Home';
import React from 'react';
import { Transfer } from './Transfer';
import AlignHome from './AlignHome';
import AlignAdminHome from './AlignAdminHome';
import SubscriptionHome from './SubscriptionHome';

const HomeBaseRoutes = () => {
	let location = useLocation();

	React.useEffect(() => {}, [location]);

	return (
		<Routes>
			<Route path="transfer" element={<Transfer />} />
			<Route path="console/*" element={<Home />} />
			<Route path="align/*" element={<AlignHome />} />
			<Route path="admin/*" element={<AlignAdminHome />} />
			<Route path="subscription/*" element={<SubscriptionHome />} />
			<Route path="*" element={<Home />} />
		</Routes>
	);
};

const HomeBase = () => {
	return (
		<div>
			<HomeBaseRoutes />
		</div>
	);
};

export default HomeBase;
